// 用于身份验证页面的路由名称
export const LOGIN_ROUTE_NAME = 'Login'
export const AUTH_ROUTES_NAME = [LOGIN_ROUTE_NAME]
// 用于错误页面的路由名称
export const ERROR_ROUTE_NAME = 'Error'
export const ERROR_404_ROUTE_NAME = 'Error404'
export const ERROR_403_ROUTE_NAME = 'Error403'

// 用于不需要身份验证的页面的路由名称
export const WHITE_ROUTES_NAME = [...AUTH_ROUTES_NAME, ERROR_404_ROUTE_NAME, ERROR_403_ROUTE_NAME]

// 用于不需要重置的页面的路由名称
export const UNRESET_ROUTES = [...WHITE_ROUTES_NAME]

// 不需要携带 redirect 参数的路径前缀
export const NO_REDIRECT_PATHS = ['/', '/login']
export enum LAYOUT_COMPONENT {
  MAIN = 'MAIN',
  BLANK = 'BLANK',
  BASE = 'BASE',
  JT_PROJ = 'JT_PROJ',
  JT_ZCH = 'JT_ZCH',
  GY_PROJ = 'GY_PROJ',
  GY_ZCH = 'GY_ZCH'
}

export enum MENU_SCOPE {
  MAIN = 'MAIN'
}
